// extracted by mini-css-extract-plugin
export default {"container":"QRCodeContainer_container__Pi-jB","text":"QRCodeContainer_text__AlH3I","message":"QRCodeContainer_message__q8wfv","codeContainer":"QRCodeContainer_codeContainer__4L28+"};